import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { DISCOUNT_PERCENT, PRODUCT_PRICE } from '../../constants/DataTestIdAttributes';
import { classes } from '../../utils/Classes';
import { ContentSpacing } from '@estee/elc-base-theme';
import { PriceFormatted } from '@estee/elc-formatters';
import { Sku } from '../../domain/entities/Sku';
import { ITranslationsCollection } from '@estee/elc-service';
import { Body2 } from '@estee/elc-typography';
import { DiscountPercentOff } from '../../constants/Price';

export interface IPriceFormatted {
    className?: string;
    selectedSku: Sku;
    translations?: ITranslationsCollection;
    priceTagElement?: keyof JSX.IntrinsicElements;
}

const buildDiscountPercentText = (props: IPriceFormatted) => {
    const { selectedSku, translations } = props;
    const { discountPercentLabel = '' } = translations as ITranslationsCollection;
    const { sitewideDiscount } = selectedSku;
    const { discountPercent } = sitewideDiscount || {};

    return discountPercentLabel.replace(DiscountPercentOff.PERCENT, discountPercent);
};

export const ProductPriceFormatted = observer(function ProductPriceFormatted(
    props: IPriceFormatted
) {
    const productPriceRowWrapperClassNames = classes(
        'product-price-row-wrapper',
        'product-full-price-wrapper'
    );
    const productOriginalPriceClassNames = classes('product-original-price');
    const productPriceClassNames = classes('product-price');
    const discountPercentLabelClassNames = classes('discount-percent-label');

    const ProductPriceRowWrapper = styled.div`
        display: inline-block;
        margin-right: ${ContentSpacing.space16};
    `;

    const {
        selectedSku: { formattedPrice, formattedOriginalPrice, sitewideDiscount }
    } = props;
    const { priceTagElement } = props;
    const discountPercentLabel = sitewideDiscount && buildDiscountPercentText(props);

    return (
        <ProductPriceRowWrapper
            data-test-id={PRODUCT_PRICE}
            className={productPriceRowWrapperClassNames}
        >
            <PriceFormatted
                className={productOriginalPriceClassNames}
                formattedPrice={formattedOriginalPrice}
                isDiscounted={!!formattedPrice}
                priceTag={priceTagElement}
            />
            {discountPercentLabel && (
                <Body2
                    className={discountPercentLabelClassNames}
                    data-test-id={DISCOUNT_PERCENT}
                    dangerouslySetInnerHTML={{ __html: discountPercentLabel }}
                />
            )}
            {formattedPrice && (
                <PriceFormatted
                    className={productPriceClassNames}
                    formattedPrice={formattedPrice}
                    priceTag="p"
                />
            )}
        </ProductPriceRowWrapper>
    );
});
